"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ym = void 0;
const ym = (tagID, ...parameters) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ym is defined by the Yandex.Metrica script
    // @ts-ignore
    const ym = window.ym;
    if (!ym || !tagID) {
        return;
    }
    ym(tagID, ...parameters);
};
exports.ym = ym;
//# sourceMappingURL=ym.js.map